import { render } from "./EditorColorMenu.vue?vue&type=template&id=2f31632f"
import script from "./EditorColorMenu.vue?vue&type=script&lang=js"
export * from "./EditorColorMenu.vue?vue&type=script&lang=js"

import "./EditorColorMenu.vue?vue&type=style&index=0&id=2f31632f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__